module.exports = __webpack_public_path__ + "img/mwdgroup.1f0d9574.png";